/* ---------- BS-001's pages move up one: the single-line diagram is page 1 (#1419, the owner's decision) ----------
 * Every project opens its design on a read-only single-line diagram, page 1. CP-001 and CP-002 already start at page 2; BS-001's
 * own pages were 1 to 4 (the incoming supply, the power circuit, the control circuit, the status signals) and are 2 to 5 now. A
 * save made before keeps its drawings by page number ("1" to "4"), so they are moved to the page they are now: "1" is "2", and so
 * on. The save migration in packages/progress uses this (format 12); nothing else does.
 * Self-contained on purpose: the migration imports this file alone, not BS-001's pack. */

/** The pages a BS-001 save made before #1419 can name: each moves up one. */
const OLD_PAGES = [1, 2, 3, 4];
const moved = (k: string) => OLD_PAGES.includes(Number(k)) && String(Number(k)) === k ? String(Number(k) + 1) : k;

/** A model's drawings, each under the page it is on now; anything else in the model as it was. */
function model(m: any): any {
  if (!m || typeof m !== "object" || !m.drawings || typeof m.drawings !== "object") return m;
  return { ...m, drawings: Object.fromEntries(Object.entries(m.drawings).map(([k, d]) => [moved(k), d])) };
}

/** A page number the view kept in its ui (the design step's dPage), moved up one; the ui as it was otherwise. */
const ui = (u: any) => u && typeof u === "object" && typeof u.dPage === "number" && OLD_PAGES.includes(u.dPage) ? { ...u, dPage: u.dPage + 1 } : u;

/** One { model, ui } (the model as a JSON string or an object, as saved) with its pages moved up one. */
function one<T extends { model?: any; ui?: any }>(s: T): T {
  const asText = typeof s.model === "string", m = model(asText ? JSON.parse(s.model) : s.model ?? null);
  return { ...s, model: asText ? JSON.stringify(m) : m, ...(s.ui !== undefined ? { ui: ui(s.ui) } : {}) };
}

/** A saved BS-001 project with its pages moved up one: its own work and each earlier attempt it keeps ("Start again", #1220). */
export function renumberBs001Save<T extends { model?: any; ui?: any; attempts?: any[] }>(s: T): T {
  const out = one(s);
  return Array.isArray(s.attempts) ? { ...out, attempts: s.attempts.map(a => one(a)) } : out;
}
